import cx from 'classnames'
import Styles from './WorkflowBuilderItem.module.scss'
import { DraggableWorkflowBuilderItemProps, WorkflowBuilderItemProps } from './Types'
import { observer } from 'mobx-react-lite'
import { Draggable } from 'react-beautiful-dnd'
import { ReactComponent as GrabberIcon } from 'assets/icons/grabber16.svg'
import { Body } from './Body'
import { DeleteButton } from './DeleteButton'

export const DraggableWorkflowBuilderItem = observer(({ states, index }: DraggableWorkflowBuilderItemProps) => {
  const state = states[0]

  return (
    <Draggable key={state.key} draggableId={state.key} index={index}>
      {(provider, snapshot) => (
        <div
          ref={provider.innerRef}
          {...provider.draggableProps}
          className={cx(Styles.draggable, {
            [Styles.dragging]: snapshot.isDragging,
          })}
        >
          <WorkflowBuilderItem
            states={states}
            grabber={
              <div className={Styles.grabber} {...provider.dragHandleProps}>
                <GrabberIcon />
              </div>
            }
          />
        </div>
      )}
    </Draggable>
  )
})

const WorkflowBuilderItem = observer(({ states, grabber }: WorkflowBuilderItemProps) => {
  const state = states[0]

  return (
    <div className={Styles.item}>
      {grabber || <div className={Styles.grabber} />}
      <Body states={states} />
      <div className={Styles.rightAction}>{state.isDeletable && <DeleteButton state={state} />}</div>
    </div>
  )
})

export { WorkflowBuilderItem }
